
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boards/[boardShortLink]/[boardSlug]",
      function () {
        return require("private-next-pages/boards/[boardShortLink]/[boardSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boards/[boardShortLink]/[boardSlug]"])
      });
    }
  